module.exports = __webpack_public_path__ + "static/media/mls.bda75b8d.png";